export interface NotificationAppEvents {
  appEvents: AppEvent[];
}

export interface AppEvent {
  name: string;
  displayName: string;
  subscribed: boolean;
}

export default class EventNotificationService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/eventnotification/';

  constructor(private $http) {
    'ngInject';
  }

  getNotificationSubscriptions(): ng.IPromise<NotificationAppEvents> {
    return this.$http.get(this.baseUrl + 'appevents');
  }
}
